<a appTooltip="Adempimenti inevasi" placement="bottom" [attr.aria-label]="getAriaLabel()" [appTooltipEnabled]="true" class="dropdown-toggle"
    data-toggle="dropdown" (click)="onClick.emit($event)" href="#" role="button" aria-haspopup="true"
    aria-expanded="false">{{numNotifiche}}</a>
<div class="dropdown-menu">
    <h2>Adempimenti inevasi</h2>
    <div *ngIf="adempimenti.length > 0" class="alert_content">
        <ul adempimenti-inevasi-list class="att_completare" [adempimenti]="adempimenti" [slice]="numToView"
            [viewOption]="false">
        </ul>
        <small class="sr-only">
           Sono presenti {{numNotifiche}} adempimenti inevasi
        </small>
    </div>
    <div *ngIf="adempimenti.length == 0">
        <p class="allinea_centro">Non ci sono adempimenti</p>
        <small class="sr-only">
            Non ci sono adempimenti inevasi
        </small>
    </div>
    <div class="read_more"><a [routerLink]="['/',viewAll]" appTooltip="Vedi tutti gli adempimenti inevasi"
            [appTooltipEnabled]="true">Vedi tutti</a>
    </div>
</div>